import {register} from '../vendor/theme-scripts/theme-sections';
import {popoutSection} from '../features/popout';
import hideElement from '../util/hide-element';
import slideDown from '../util/slide-down';
import fadeIn from '../util/fade-in';
import tabs from '../features/tabs';
import {QuickAddProduct} from '../features/quick-add';
import {makeGridSwatches} from '../features/swatch';
import {Slider} from '../features/slider';

const selectors = {
  dataRelatedSectionElem: '[data-related-section]',
  dataRelatedProduct: '[data-product-grid-item]',
  dataProductId: 'data-product-id',
  dataLimit: 'data-limit',
  dataMinimum: 'data-minimum',
  recentlyViewed: '[data-recent-wrapper]',
  recentlyViewedWrapper: '[data-recently-viewed-wrapper]',
  recentlyProduct: '#recently-viewed-products',
  dataProductItem: '.product-item',
  slider: '[data-slider]',
};

const classes = {
  isHidden: 'is-hidden',
};

class Related {
  constructor(section) {
    this.section = section;
    this.sectionId = section.id;
    this.container = section.container;

    this.init();
    this.recent();
  }

  init() {
    const relatedSection = this.container.querySelector(selectors.dataRelatedSectionElem);

    if (!relatedSection) {
      return;
    }

    const self = this;
    const productId = relatedSection.getAttribute(selectors.dataProductId);
    const limit = relatedSection.getAttribute(selectors.dataLimit);
    const requestUrl = `${window.theme.routes.product_recommendations_url}?section_id=related&limit=${limit}&product_id=${productId}`;

    fetch(requestUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        const createdElement = document.createElement('div');
        createdElement.innerHTML = data;
        const inner = createdElement.querySelector(selectors.dataRelatedSectionElem);

        if (inner.querySelector(selectors.dataRelatedProduct)) {
          const innerHtml = inner.innerHTML;
          hideElement(relatedSection);
          relatedSection.innerHTML = innerHtml;
          slideDown(relatedSection);

          const relatedProducts = relatedSection.querySelectorAll(selectors.dataRelatedProduct);

          relatedProducts.forEach((item) => {
            new QuickAddProduct(item);
          });

          makeGridSwatches(self.section);

          if (relatedProducts.length > 4 && relatedSection.querySelector(selectors.slider)) {
            new Slider(relatedSection);
          }
        } else {
          relatedSection.dispatchEvent(
            new CustomEvent('tabs:hideRelatedTab', {
              bubbles: true,
            })
          );
        }
      })
      .catch(function () {
        relatedSection.dispatchEvent(
          new CustomEvent('tabs:hideRelatedTab', {
            bubbles: true,
          })
        );
      });
  }

  recent() {
    const recentlyViewed = this.container.querySelector(selectors.recentlyViewed);
    const howManyToshow = recentlyViewed ? parseInt(recentlyViewed.getAttribute(selectors.dataLimit)) : 4;

    Shopify.Products.showRecentlyViewed({
      howManyToShow: howManyToshow,
      wrapperId: `recently-viewed-products-${this.sectionId}`,
      section: this.section,
      onComplete: (wrapper, section) => {
        const container = section.container;
        const recentlyViewedHolder = container.querySelector(selectors.recentlyViewed);
        const recentlyViewedWrapper = container.querySelector(selectors.recentlyViewedWrapper);
        const recentProducts = wrapper.querySelectorAll(selectors.dataProductItem);
        const minimumNumberProducts = recentlyViewedHolder.hasAttribute(selectors.dataMinimum) ? parseInt(recentlyViewedHolder.getAttribute(selectors.dataMinimum)) : 4;
        const checkRecentInRelated = !recentlyViewedWrapper && recentProducts.length > 0;
        const checkRecentOutsideRelated = recentlyViewedWrapper && recentProducts.length >= minimumNumberProducts;

        if (checkRecentInRelated || checkRecentOutsideRelated) {
          if (checkRecentOutsideRelated) {
            recentlyViewedWrapper.classList.remove(classes.isHidden);
          }

          fadeIn(recentlyViewedHolder);

          recentlyViewedHolder.dispatchEvent(
            new CustomEvent('tabs:checkRecentTab', {
              bubbles: true,
            })
          );

          recentProducts.forEach((item) => {
            new QuickAddProduct(item);
          });

          makeGridSwatches(section);

          if (recentProducts.length > 4 && recentlyViewedHolder.querySelector(selectors.slider)) {
            new Slider(recentlyViewedHolder);
          }
        }
      },
    });
  }
}

const relatedSection = {
  onLoad() {
    this.section = new Related(this);

    this.container.querySelectorAll(selectors.dataRelatedProduct).forEach((item) => {
      new QuickAddProduct(item);
    });
  },
};

register('related', [relatedSection, popoutSection, tabs]);
